import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { ProjectService } from 'src/app/services/project.service';
import { PopupConfigurationTerrainComponent } from '../../configuration-terrain/configuration-terrain.component';
import { HttpClient } from '@angular/common/http';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { cloneDeep } from 'lodash';
import { ConfigurationTerrain } from 'src/app/models/terrains';
import { ProgressService } from 'src/app/services/progress.service';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';

@Component({
  selector: 'app-terrains',
  templateUrl: './terrains.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class TerrainsComponent implements OnInit {

  configurationController : ConfigurationService;

  selectedTerrain: number = -1;

  constructor(configurationController : ConfigurationService,
    private modalService: ModalControlService,
    private projectService : ProjectService,
    private popupService: BsModalService,
    public bsModalRef : BsModalRef,
    private uiBlock: UiBlockService,
    private readonly modelConfirmationMessage: ModalConfirmationService,
    ) {
      this.configurationController = configurationController;
    }

  async ngOnInit(){
    this.uiBlock.startBlock("Fetching Terrains...");
    try {
      await this.configurationController.fetchTerrainTypesPromiseRequest();
      this.configurationController.fetchTerrainsByProject(this.projectService.activeProject.id);
      this.configurationController.saveChangesState();
    } finally {
      this.uiBlock.stopBlock();
    } 
  }

  cancelConfiguration():void {
    this.bsModalRef.hide();
  }

  moveUp(){
    if(!this.projectService.projectEditable()){
      return;
    }
    if (this.someTerrainSelected() && this.selectedTerrain - 1 >= 0){
      this.configurationController.savedTerrains$.getValue()[this.selectedTerrain].position--;
      this.configurationController.savedTerrains$.getValue()[this.selectedTerrain - 1].position++;
      const temp = this.configurationController.savedTerrains$.getValue()[this.selectedTerrain];
      this.configurationController.savedTerrains$.getValue()[this.selectedTerrain] = this.configurationController.savedTerrains$.getValue()[this.selectedTerrain - 1];
      this.configurationController.savedTerrains$.getValue()[this.selectedTerrain - 1] = temp;
      this.selectedTerrain--;
    }
  }

  moveDown(){
    if(!this.projectService.projectEditable()){
      return;
    }
    if (this.someTerrainSelected() && this.selectedTerrain + 1 < this.configurationController.savedTerrains$.getValue().length){
      this.configurationController.savedTerrains$.getValue()[this.selectedTerrain].position++;
      this.configurationController.savedTerrains$.getValue()[this.selectedTerrain + 1].position--;
      const temp = this.configurationController.savedTerrains$.getValue()[this.selectedTerrain];
      this.configurationController.savedTerrains$.getValue()[this.selectedTerrain] = this.configurationController.savedTerrains$.getValue()[this.selectedTerrain + 1];
      this.configurationController.savedTerrains$.getValue()[this.selectedTerrain + 1] = temp;
      this.selectedTerrain++;
    }
  }

  async saveConfiguration(showMessage: boolean = true, showUiBlock: boolean = true) {
    if (this.projectService.projectEditable()) {
      
      const success = await this.configurationController.deleteCalculationsDatabase();
      if (!success) {
        return false;
      }

      showUiBlock? this.uiBlock.startBlock("Performing validations..."): false
      try {
        let message: string = ' or click "cancel"';
        !showMessage? message = '': false; 
        if (!(await this.configurationController.operationAllowedByCalculationManager())){
          throw new Error("Calculations are in progress");
        }
        const terrainBeingUploaded: boolean = await this.configurationController.getTerrainUploadInProgress();
        if (terrainBeingUploaded){
          this.modalService.showMesssageModal(
            'Terrains Error',
            `A terrain is being uploaded, you cannot modidy terrains. Please wait for it to finish${message}.` +
            ' If this is not the case, please refresh the page.' 
          );
          throw new Error("Terrain being uploaded");
        }
        let allUpdated: boolean = true;
        for (const terrain of this.configurationController.savedTerrains$.getValue()) {
          const formData = ConfigurationTerrain.mapToFormData(terrain);
          const savedTerrain: ConfigurationTerrain = await this.configurationController.updateTerrain(formData);
          if (savedTerrain == null){
            allUpdated = false;
            this.modalService.showMesssageModal(
              'Update Terrain Error',
              'Error updating terrain: ' + terrain.name +  '.'
            );
          }
        }
        allUpdated && showMessage? this.modalService.showMesssageModal(
          'Update Terrain',
          'Terrains updated successfully.'
        ): false
      } finally {
        showUiBlock? this.uiBlock.stopBlock(): false;
      }
    }
    showMessage ? this.bsModalRef.hide() : false;
    this.configurationController.fetchTerrainsByProject(this.projectService.activeProject.id);
    this.configurationController.saveChangesState();
    return true;
  }

  private removeTerrainFromList(index: number){
    this.configurationController.savedTerrains$.getValue().splice(index, 1);
    for (index; index<this.configurationController.savedTerrains$.getValue().length;index++){
      this.configurationController.savedTerrains$.getValue()[index].position--;
    }
  }

  selectTerrain(i : number): void{
    if(i != this.selectedTerrain){
      if(this.selectedTerrain >= 0 && this.selectedTerrain < this.configurationController.savedTerrains$.getValue().length){
        this.configurationController.savedTerrains$.getValue()[this.selectedTerrain].isselected = false;
      }
      this.selectedTerrain = i;
      this.configurationController.savedTerrains$.getValue()[i].isselected = true;
    }
    else{
      var currentRow = this.selectedTerrain;
      if(this.configurationController.savedTerrains$.getValue()[this.selectedTerrain].isselected){
        this.selectedTerrain = -1;
      }

      this.configurationController.savedTerrains$.getValue()[currentRow].isselected = !this.configurationController.savedTerrains$.getValue()[currentRow].isselected;
    }
  }

  async addTerrain():Promise<void> {
    if(!this.projectService.projectEditable()){
      return;
    }
    if (!(await this.saveConfiguration(false))) {
      return;
    }
    this.configurationController.terrainEditMode = false;
    const bsModalRef : BsModalRef = this.popupService.show(PopupConfigurationTerrainComponent);
    bsModalRef.content.previousBsModalRef = this.bsModalRef;
  }

  async editTerrain():Promise<void> {
    if(this.projectService.projectEditable()){
      if(this.someTerrainSelected()){
        const terrainBeingValidated: boolean = await this.configurationController.getTerrainValidationInProgress(
          this.configurationController.savedTerrains$.getValue()[this.selectedTerrain].id
          );
        if (terrainBeingValidated){
          this.modalService.showMesssageModal(
            'Terrains Error',
            'The selected terrain is being validated. Please wait for it to finish.'
          );
          return;
        }
        if (!(await this.saveConfiguration(false))) {
          return;
        }
        const terrainToEdit = cloneDeep(this.configurationController.savedTerrains$.getValue()[this.selectedTerrain]);
        this.configurationController.terrainEditMode = true;
        this.configurationController.terrainToEdit = terrainToEdit;
        const bsModalRef : BsModalRef = this.popupService.show(PopupConfigurationTerrainComponent);
        bsModalRef.content.selectedRow = this.selectedTerrain;
        bsModalRef.content.previousBsModalRef = this.bsModalRef;
      }
    }
  }

  private someTerrainSelected(): boolean{
    if(this.selectedTerrain >= 0 && this.selectedTerrain < this.configurationController.savedTerrains$.getValue().length){
      return true;
    }
    else{
      this.modalService.showMesssageModal("Configuration Terrain", "You have to select a terrain.");
      return false;
    }
  }

  private isDefaultTerrain(terrain: ConfigurationTerrain): boolean {
    return terrain.name == ConfigurationTerrain.DEFAULT_TERRAIN_NAME || terrain.name == ConfigurationTerrain.DEFAULT_GTOPO30
  }


  async deleteTerrain(): Promise<void> {
    if(!this.projectService.projectEditable()){
      return;
    }
    if(this.someTerrainSelected()){
      if (this.configurationController.savedTerrains$.getValue()[this.selectedTerrain].name == ConfigurationTerrain.DEFAULT_TERRAIN_NAME ||
        this.configurationController.savedTerrains$.getValue()[this.selectedTerrain].name == ConfigurationTerrain.DEFAULT_GTOPO30){
        // this.modalService.showMesssageModal("Delete Terrain Error", "You must have at least one active GTOPO30 terrain");
        this.modalService.showMesssageModal("Delete Terrain Error", "You can not delete the default terrains");
        return;
      }
      if (!this.configurationController.validateTerrainEditOrDelete(this.configurationController.savedTerrains$.getValue()[this.selectedTerrain], this.selectedTerrain)){
        this.modalService.showMesssageModal("Terrain Error", "There must be at least one active DTED1 terrain in current project.");
        return;
      }
      const terrainBeingValidated: boolean = await this.configurationController.getTerrainValidationInProgress(
        this.configurationController.savedTerrains$.getValue()[this.selectedTerrain].id
      );
      if (terrainBeingValidated) {
        this.modalService.showMesssageModal(
          'Terrains Error',
          'The selected terrain is being validated. Please wait for it to finish.'
        );
        return;
      }
      if (!(await this.saveConfiguration(false, false))) {
        return;
      }
      this.uiBlock.startBlock("Deleting Terrain...");
      try {
        // terrain is saved, delete from DB and list
        const deleted: boolean = await this.configurationController.deleteTerrain(this.configurationController.savedTerrains$.getValue()[this.selectedTerrain].id);
        if (!deleted){
          this.modalService.showMesssageModal("Delete Terrain Error", "Error deleting terrain: " + this.configurationController.savedTerrains$.getValue()[this.selectedTerrain].name);
        } else {
          this.removeTerrainFromList(this.selectedTerrain);
          this.modalService.showMesssageModal("Delete Terrain", "Terrain deleted sucessfully.");
        }
      } finally {
        this.uiBlock.stopBlock();
      }
    }
  }
}
